module.exports = __webpack_public_path__ + "img/signed-for-departed-soles.3696dfbd.jpeg";